import { React } from "react";
import { Box } from "@mui/system";

import AssignTarget from "./assignTarget/AssignTarget.component";
import { ManageUserStyle } from "./ManageUser.style";
import BreadcrumbsComponent from "../../base/Breadcrumbs.component";
import { Button } from "@mui/material";
import { PersonAddAlt1 } from "@mui/icons-material";
import { TYPE } from "../../../utils/Utils";
import HocPopup from "../../../hoc/hocPopup";
import UserDialog from "./dialog/dialogBody/User.dialog";

const breadcrumb = {
  title: "Manage User",
  links: [
    { path: "/", name: "Home" },
    { path: null, name: "Manage User" },
  ],
};

const ManageUserComponent = ({ dialog }) => {
  return (
    <Box >
      {/* <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          mt: "30px",
        }}
      >
        <BreadcrumbsComponent {...breadcrumb} />
        <Button
          variant="text"
          sx={{ height: "40px", alignSelf: "flex-end", marginRight: "16px" }}
          startIcon={<PersonAddAlt1 />}
          onClick={() => {
            dialog({
              open: true,
              bodyType: TYPE.ADD_USER,
              body: <UserDialog />,
            });
          }}
        >
          Add User
        </Button>
      </Box> */}

      <AssignTarget />
    </Box>
  );
};

export default HocPopup(ManageUserComponent);
